import type { Product } from '../../../models/Product';
import { ProductMixAndMatch as ProductMixAndMatchVM } from '../../../models/ProductMixAndMatch';
import ProductMixAndMatchItem from './ProductMixAndMatchItem';
import './ProductMixAndMatchList.less';
import EmptyProductSearchResult from '../search/EmptyProductSearchResult';
import MainFeatureHeader from '../common/MainFeatureHeader';
import { useTranslation } from '../../../hooks/useTranslation';

export type ProductMixAndMatchListProps = {
    fixedProducts: Product[];
    groups: ProductMixAndMatchVM[];
    onAddToCart: (products: Product[]) => void;
};

const ProductMixAndMatchList = ({
    fixedProducts,
    groups,
    onAddToCart
}: ProductMixAndMatchListProps) => {
    const { t } = useTranslation();
    return (
        <>
            <MainFeatureHeader
                preTitle={t('PRODUCT_MIX_AND_MATCH_RESULTS_PRETITLE')}
                title={
                    fixedProducts.length === 1
                        ? fixedProducts[0].name
                        : t('PRODUCTS_LABEL_MANY', {
                              count: fixedProducts.length
                          })
                }
                products={fixedProducts}
                visibleActions={[
                    'add-to-cart',
                    'product-search-similar',
                    'product-search-combinations',
                    'compare'
                ]}
            />
            {groups.length === 0 ? (
                <EmptyProductSearchResult />
            ) : (
                <div className={`bri-ProductMixAndMatchList`}>
                    {groups.map((group, index) => (
                        <>
                            <ProductMixAndMatchItem
                                key={group.title}
                                fixedProducts={fixedProducts}
                                group={group}
                                onAddToCart={onAddToCart}
                                source="brilliant"
                            />
                            {index < groups.length - 1 && (
                                <div className="bri-ProductMixAndMatchList-divider" />
                            )}
                        </>
                    ))}
                </div>
            )}
        </>
    );
};

export default ProductMixAndMatchList;
